import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import styled from 'styled-components';
import Clearfix from 'components/elements/clearfix';
import { getAllLookupLoaiHoSo } from 'api/lookuplistitemApi';
import { SELECT_ITEM_DEFAULT } from 'config';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

export default class LoaiHoSoSelect extends React.Component {
  static propTypes = {
    width: PropTypes.any,
    hideLabel: PropTypes.bool,
    fieldForm: PropTypes.shape({
      form: PropTypes.any,
      name: PropTypes.string,
      option: PropTypes.object,
    }),
  };

  state = {
    itemList: [SELECT_ITEM_DEFAULT],
  };

  componentWillMount = async () => {
    const res = await getAllLookupLoaiHoSo();
    if (res.success)
      this.setState({
        itemList: [
          SELECT_ITEM_DEFAULT,
          ...res.data.map((item) => {
            // return { value: item._id, label: item.Name };
            // NOTE Qui: đã trao đổi với thảo. để fix bug lỗi thì lấy Name làm value. thảo nói hiện tại chỉ hiển thị k ảnh hương logic. Chị THạnh yêu cầu vì không muốn người dùng cuối nhập sai
            return { value: item.Name, label: item.Name };
          }),
        ],
      });
  };

  handleOnchange = (obj) => {
    const { fieldForm } = this.props;
    let getFieldProps = {};
    if (fieldForm) {
      getFieldProps = fieldForm.form.getFieldProps(fieldForm.name, {
        ...fieldForm.option,
      });

      getFieldProps.onChange(obj && obj.value ? obj : undefined);
    }
  };

  render() {
    const { fieldForm } = this.props;
    let getFieldProps = {};
    if (fieldForm) {
      getFieldProps = fieldForm.form.getFieldProps(fieldForm.name, {
        ...fieldForm.option,
      });
    }

    const isHidden = {
      style: {
        display: this.props.hideLabel ? 'none' : '',
      },
    };
    console.log(getFieldProps, '--getFieldProps--');

    return (
      <Container>
        <span {...isHidden}>Tên hồ sơ</span>
        <Clearfix {...isHidden} width={8} />
        <div style={{ flex: 1 }}>
          <Select
            isClearable
            placeholder='-- Select --'
            style={{
              flex: 1,
            }}
            classNamePrefix='react-select-custom'
            options={this.state.itemList}
            {...getFieldProps}
            onChange={this.handleOnchange}
          />
        </div>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/select-loai-ho-so/index.js